(function ($) {

	function updateEdgeClasses(swiper, el) {
		const $wrapper = el.closest('.cart-cross-sell__overflow');

		if (swiper.isLocked) {
			$wrapper.addClass('-at-end');
			return;
		}

		if (swiper.isBeginning) {
			$wrapper.removeClass('-at-end');
		} else if (swiper.isEnd) {
			$wrapper.addClass('-at-end');
		} else {
			$wrapper.removeClass('-at-end');
		}
	}

	function productSlider() {
		$(".cart-cross-sell__container").each(function () {
			var $this = $(this);
			var Slider = new Swiper($this[0], {
				slidesPerView: 'auto',
				spaceBetween: 8,
				freeMode: true,
				mousewheel: {
					forceToAxis: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				on: {
					init: function () {
						updateEdgeClasses(this, $this);
					},
					resize: function () {
						updateEdgeClasses(this, $this);
					},
					setTranslate: function () {
						updateEdgeClasses(this, $this);
					},
				},
			});

			if ($(this).find('.swiper-slide').length < 2) {
				Slider.destroy();
			}
			window.onresize = function () {
				Slider.update();
			}
		});
	}

	$(document).gp_ready(productSlider)

	//
	// function toggleSizes() {
	//
	// 	$('.cart__cross_sizes-btn').click(function (e) {
	// 		e.preventDefault();
	// 		$(this).hide();
	// 		$(this).siblings('.cart__cross_sizes-wrapper').removeClass('--hidden');
	// 	});
	// }
	//
	// toggleSizes();
	//
	// jQuery('body').on('loading_end', function () {
	// 	toggleSizes();
	// 	productSlider();
	// });

	// function add_cart_item(e) {
	//
	//     e.preventDefault();
	//
	//     gp_ajax({
	//         url: ghostpress_params.ajax_url + "&action=cart_add_product_variant",
	//         type: "post",
	//         dataType: "json",
	//         data: $(this).serializeArray(),
	//         show_loading: true
	//     })
	// }
	//
	// function init_cart() {
	//     $('.cart__cross .form-add-to-cart').off('submit').submit(add_cart_item)
	// }
	//
	// $(document).gp_ready(init_cart)

})(jQuery);
